var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixRestaurantsV3Order from '@wix/ambassador-restaurants-v3-order/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
/** This might be extended in the future with pending orders statuses */
export var Status;
(function (Status) {
    /** Order status can't be classified, due to an error */
    Status["UNSPECIFIED_ORDER_STATUS"] = "UNSPECIFIED_ORDER_STATUS";
    /** Order is pending response from the payment provider - IF THIS WILL REMAIN PAYMENT PROVIDER SPECIFIC, THIS SHOULD BE CLEAR FROM THE NAME - E.G. PENDING_PAYMENT_PROVIDER. */
    Status["PENDING"] = "PENDING";
    /** The order is marked as new - wait for state machine */
    Status["NEW"] = "NEW";
    /** Order was accepted */
    Status["ACCEPTED"] = "ACCEPTED";
    /** Order is canceled */
    Status["CANCELED"] = "CANCELED";
    /** Order is fulfilled */
    Status["FULFILLED"] = "FULFILLED";
})(Status || (Status = {}));
export var DisplayType;
(function (DisplayType) {
    /** DisplayType, due to an error */
    DisplayType["UNSPECIFIED_DISPLAY_TYPE"] = "UNSPECIFIED_DISPLAY_TYPE";
    /** Single choice selection */
    DisplayType["SELECTION"] = "SELECTION";
    /** Multiple choices selection */
    DisplayType["EXTRAS"] = "EXTRAS";
    /** Allow choices removal */
    DisplayType["DESELECTION"] = "DESELECTION";
})(DisplayType || (DisplayType = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["UNSPECIFIED_TYPE"] = "UNSPECIFIED_TYPE";
    DiscountType["OFF_ITEM"] = "OFF_ITEM";
    DiscountType["OFF_ORDER"] = "OFF_ORDER";
    DiscountType["OFF_ORDER_MANAGER_DISCOUNT"] = "OFF_ORDER_MANAGER_DISCOUNT";
})(DiscountType || (DiscountType = {}));
export var PaymentType;
(function (PaymentType) {
    /** PaymentType, due to an error */
    PaymentType["UNSPECIFIED_PAYMENT_TYPE"] = "UNSPECIFIED_PAYMENT_TYPE";
    /** Cash */
    PaymentType["CASH"] = "CASH";
    /** credit */
    PaymentType["CREDIT"] = "CREDIT";
    /** Delivery club */
    PaymentType["DELIVERY_CLUB"] = "DELIVERY_CLUB";
    /** Delivery com */
    PaymentType["DELIVERY_COM"] = "DELIVERY_COM";
    /** Bitpay */
    PaymentType["BITPAY"] = "BITPAY";
    /** Cellarix */
    PaymentType["CELLARIX"] = "CELLARIX";
    /** Bits of gold */
    PaymentType["BITSOFGOLD"] = "BITSOFGOLD";
    /** Multi pass */
    PaymentType["MULTIPASS"] = "MULTIPASS";
    /** Tenbis */
    PaymentType["TENBIS"] = "TENBIS";
    /** Paypal */
    PaymentType["PAYPAL"] = "PAYPAL";
    /** Mysodexo */
    PaymentType["MYSODEXO"] = "MYSODEXO";
    /** Wix Payments */
    PaymentType["WIX_PAYMENTS"] = "WIX_PAYMENTS";
})(PaymentType || (PaymentType = {}));
export var FulfillmentType;
(function (FulfillmentType) {
    /** Missing type due to an error */
    FulfillmentType["UNSPECIFIED_FULFILLMENT_TYPE"] = "UNSPECIFIED_FULFILLMENT_TYPE";
    /** Pickup */
    FulfillmentType["PICKUP"] = "PICKUP";
    /** Delivery */
    FulfillmentType["DELIVERY"] = "DELIVERY";
    /** Dine-in */
    FulfillmentType["DINE_IN"] = "DINE_IN";
})(FulfillmentType || (FulfillmentType = {}));
export var OnArrival;
(function (OnArrival) {
    /** Missing type due to an error */
    OnArrival["UNSPECIFIED_ON_ARRIVAL_TYPE"] = "UNSPECIFIED_ON_ARRIVAL_TYPE";
    /** Buzz the door */
    OnArrival["BUZZ_DOOR"] = "BUZZ_DOOR";
    /** Phone me */
    OnArrival["CALL_ME"] = "CALL_ME";
})(OnArrival || (OnArrival = {}));
export var Type;
(function (Type) {
    Type["UNSPECIFIED_CHANNEL_TYPE"] = "UNSPECIFIED_CHANNEL_TYPE";
    /** Web */
    Type["WEB"] = "WEB";
    /** mobileWeb */
    Type["MOBILE_WEB"] = "MOBILE_WEB";
    /** mobile */
    Type["MOBILE"] = "MOBILE";
    /** callCenter */
    Type["CALL_CENTER"] = "CALL_CENTER";
    /** facebook */
    Type["FACEBOOK"] = "FACEBOOK";
    /** TPA */
    Type["TPA"] = "TPA";
})(Type || (Type = {}));
export var FieldName;
(function (FieldName) {
    FieldName["CREATED_DATE"] = "CREATED_DATE";
    FieldName["UPDATED_DATE"] = "UPDATED_DATE";
    FieldName["PROMISED_TIME"] = "PROMISED_TIME";
})(FieldName || (FieldName = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var EventType;
(function (EventType) {
    /** Order event can't be classified, due to an error/unhandled event */
    EventType["UNKNOWN"] = "UNKNOWN";
    /** Order Created. */
    EventType["CREATED"] = "CREATED";
    /** Order accepted */
    EventType["ACCEPTED"] = "ACCEPTED";
    /** Order Canceled */
    EventType["CANCELED"] = "CANCELED";
    /** Order Fulfilled */
    EventType["FULFILLED"] = "FULFILLED";
})(EventType || (EventType = {}));
const _acceptOrderRequest = {};
const _acceptOrderResponse = { order: '_order' };
const _cancelOrderRequest = {};
const _cancelOrderResponse = { order: '_order' };
const _countOrdersRequest = {};
const _countOrdersResponse = {};
const _fulfillOrderRequest = {};
const _fulfillOrderResponse = { order: '_order' };
const _getOrderByMsidRequest = {};
const _getOrderByMsidResponse = { order: '_order' };
const _getOrderRequest = {};
const _getOrderResponse = { order: '_order' };
const _getTotalActiveOrdersRequest = {};
const _getTotalActiveOrdersResponse = {};
const _lineItem = { dishOptions: '_lineItemOption' };
const _lineItemOption = { selectedChoices: '_lineItem' };
const _listOrdersByMsidRequest = {};
const _listOrdersByMsidResponse = { orders: '_order' };
const _listOrdersRequest = {};
const _listOrdersResponse = { orders: '_order' };
const _notifyOrderEventRequest = {};
const _notifyOrderEventResponse = {};
const _order = { lineItems: '_lineItem' };
/**
 * return list of orders total amount mapped to each location based on given status.
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function getTotalActiveOrders(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            locationId: '$[0].locationId',
            organizationId: '$[0].organizationId',
            promisedTimeNew: '$[0].promisedTimeNew',
            promisedTimeInProgress: '$[0].promisedTimeInProgress',
            restaurantLocationId: '$[0].restaurantLocationId',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getTotalActiveOrdersRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getTotalActiveOrdersResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixRestaurantsV3Order.getTotalActiveOrders(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * TEST The `getOrder()` function returns a Promise that is returned when an order is retrieved.
 *
 * 1. First do this.
 * 1. The do that
 *     + This is a bullet
 *     + So is this.
 *
 * > **Note**: This indentation is not how our notes generally look but I will waiit to see the branch preview. I am just trying out some markdown here.
 *
 * @param _id - ID of the order to retrieve.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @adminMethod
 * @returns TEST Curious where this shows up.
 */
export function getOrder(_id, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]', fieldMask: '$[1].fieldMask' };
        const responseTransformation = '$.order';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getOrderRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getOrderResponse,
            depSchemas: { _lineItem, _lineItemOption, _order },
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, options]);
        const reqOpts = ambassadorWixRestaurantsV3Order.getOrder(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of up to 1000 orders, given the provided filters.
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function listOrders(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            fieldMask: '$[0].fieldMask',
            status: '$[0].status',
            createdDate: '$[0]._createdDate',
            delivered: '$[0].delivered',
            locationIds: '$[0].locationIds',
            sort: '$[0].sort',
            limit: '$[0].limit',
            cursorPaging: '$[0].cursorPaging',
            phone: '$[0].phone',
            asap: '$[0].asap',
            promisedTime: '$[0].promisedTime',
            restaurantLocationIds: '$[0].restaurantLocationIds',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listOrdersRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listOrdersResponse,
            depSchemas: { _lineItem, _lineItemOption, _order },
            fqdnTransformation: {
                paths: [...['Array#orders']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixRestaurantsV3Order.listOrders(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Changes the order status to `ACCEPTED`.
 *
 * > **Note:** It is not possible to change the order status from `FULFILLED` to `ACCEPTED`.
 * @param _id - ID of the order to mark as `ACCEPTED`.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @adminMethod
 */
export function acceptOrder(_id, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            id: '$[0]',
            message: '$[1].message',
            pickupTime: '$[1].pickupTime',
            dropOffTime: '$[1].dropOffTime',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _acceptOrderRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _acceptOrderResponse,
            depSchemas: { _lineItem, _lineItemOption, _order },
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, options]);
        const reqOpts = ambassadorWixRestaurantsV3Order.acceptOrder(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Changes the order status to `CANCELED`.
 * @param _id - ID of the order to mark as `CANCELED`.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @adminMethod
 */
export function cancelOrder(_id, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]', message: '$[1].message' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _cancelOrderRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _cancelOrderResponse,
            depSchemas: { _lineItem, _lineItemOption, _order },
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, options]);
        const reqOpts = ambassadorWixRestaurantsV3Order.cancelOrder(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Changes the order status to `FULFILLED`.
 * @param _id - ID of the order to mark as `FULFILLED`.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @adminMethod
 */
export function fulfillOrder(_id) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _fulfillOrderRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _fulfillOrderResponse,
            depSchemas: { _lineItem, _lineItemOption, _order },
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id]);
        const reqOpts = ambassadorWixRestaurantsV3Order.fulfillOrder(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Returns the number of orders that match the query.
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function countOrders(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            restaurantLocationId: '$[0].restaurantLocationId',
            query: '$[0].query',
            locationId: '$[0].locationId',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _countOrdersRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _countOrdersResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixRestaurantsV3Order.countOrders(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves an order.
 * @param _id - Order ID.
 * @param msid - Metasite id
 * @internal
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField msid
 * @adminMethod
 */
export function getOrderByMsid(_id, msid, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            id: '$[0]',
            msid: '$[1]',
            fieldMask: '$[2].fieldMask',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getOrderByMsidRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getOrderByMsidResponse,
            depSchemas: { _lineItem, _lineItemOption, _order },
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, msid, options]);
        const reqOpts = ambassadorWixRestaurantsV3Order.getOrderByMsid(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'msid',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of up to 2000 orders, given the provided filters.
 * @internal
 * @documentationMaturity preview
 * @requiredField options.msid
 * @adminMethod
 */
export function listOrdersByMsid(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            fieldMask: '$[0].fieldMask',
            status: '$[0].status',
            createdDate: '$[0]._createdDate',
            delivered: '$[0].delivered',
            sort: '$[0].sort',
            limit: '$[0].limit',
            msid: '$[0].msid',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listOrdersByMsidRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listOrdersByMsidResponse,
            depSchemas: { _lineItem, _lineItemOption, _order },
            fqdnTransformation: {
                paths: [...['Array#orders']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixRestaurantsV3Order.listOrdersByMsid(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @param _id - Order ID.
 * @internal
 * @documentationMaturity preview
 * @requiredField _id
 * @adminMethod
 */
export function notifyOrderEvent(_id, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            id: '$[0]',
            msid: '$[1].msid',
            eventType: '$[1].eventType',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _notifyOrderEventRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _notifyOrderEventResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, options]);
        const reqOpts = ambassadorWixRestaurantsV3Order.notifyOrderEvent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=restaurants-v3-order.universal.js.map